import type { AgendaDesign } from "#internal"

const WEEK: AgendaDesign = {
  badge: false,
  columns: false,
  contacts: 5,
  dated: true,
  hours: false,
  left: 3,
  months: false,
  notes: false,
  planner: 0,
  pages: "week_spread",
  title: 9,
}
const DAY: AgendaDesign = { ...WEEK, hours: true, pages: "day" }

/** The agendas' designs: the generic ones, a week a spread or a day a page,
 * and one for each of the shop's templates — Kiona's days on a badge,
 * Altair's plain, Leixo's by the hour after the year planned, Papyrus's by the hour after the
 * year's months, both in columns, Perpetual's undated, four days on its left page,
 * Muna's a week a page. */
export const AgendaDesigns = {
  altair: WEEK,
  daily: DAY,
  kiona: { ...WEEK, badge: true, planner: 6 },
  kiona_daily: { ...DAY, badge: true, planner: 6 },
  leixo: { ...WEEK, columns: true, hours: true, planner: 6 },
  muna: { ...WEEK, contacts: 0, pages: "week_page", planner: 2, title: 5 },
  papyrus: {
    ...WEEK,
    columns: true,
    contacts: 0,
    hours: true,
    left: 4,
    months: true,
    notes: true,
    title: 15,
  },
  perpetual: { ...WEEK, contacts: 0, dated: false, left: 4, title: 5 },
  perpetual_daily: { ...DAY, contacts: 0, dated: false, title: 5 },
  weekly: WEEK,
} as const satisfies Record<string, AgendaDesign>
